import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import HAD from "../../../../assets/imgs/contactUs/HAD.png";
import classes from "./contactus.module.css";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTimes,
  FaWhatsapp,
} from "react-icons/fa";

function ContactUs(props) {
  function handleModalClose() {
    props.setOpen(false);
  }

  return (
    <Modal open={props.open} onClose={handleModalClose}>
      <Box className={classes.box}>
        <div className={classes.container}>
          <div className={classes.close}>
            <button
              style={{
                display: " flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={handleModalClose}
            >
              <FaTimes size="1.5rem" />
            </button>
          </div>
          <h1 className={classes.title}>Contact Us</h1>
          <div className={classes.info}>
            <div className={classes.infoData}>
              <div className={classes.infoItem}>
                <FaMapMarkerAlt
                  color="var(--green)"
                  aria-label="location"
                  size="2rem"
                />
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://goo.gl/maps/mfT5CPHTerhcjLWP7"
                >
                  15 Al Mahrouki. Ard Al Golf, Cairo Egypt.
                </a>
              </div>
              <div className={classes.infoItem}>
                <FaEnvelope
                  color="var(--green)"
                  aria-label="email"
                  size="1.8rem"
                />
                <a href="mailto:Info@have-adream.com">Info@have-adream.com</a>
              </div>
              <div className={classes.infoItem}>
                <FaPhone
                  color="var(--green)"
                  aria-label="phone"
                  size="1.8rem"
                />
                <a href="tel:+20 1094414168">+20 01094414168</a>
              </div>
              <div className={classes.infoItem}>
                <FaWhatsapp
                  color="var(--green)"
                  aria-label="whatsapp"
                  size="2rem"
                />
                <div className={classes.whatsappNumbers}>
                  <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://wa.me/201094414168"
                  >
                    +20 109 441 4168
                  </a>
                </div>
              </div>
              <div className={classes.infoItem3}>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://www.facebook.com/haveadream.org"
                >
                  <FaFacebookF
                    color="var(--green)"
                    aria-label="facebook"
                    size="2rem"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://www.instagram.com/have.adream/"
                >
                  <FaInstagram
                    color="var(--green)"
                    aria-label="instagram"
                    size="2rem"
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://www.linkedin.com/company/have-a-dream-organization/"
                >
                  <FaLinkedinIn
                    color="var(--green)"
                    aria-label="linkedin"
                    size="2rem"
                  />
                </a>
              </div>
            </div>
            <div className={classes.picture}>
              <img src={HAD} alt="HAD" className={classes.imgHad} />
              <p>We'll answer as Soon as we Can </p>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ContactUs;
